var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 108",
    style: {
      enableBackground: "new 0 0 144 108"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#34394D;}\n\t.st1{fill:#EF7F24;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000026158954916401332950000014294946096729813951_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.4,39.2h9.9v46.9h-9.9V39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.8,54.1c-1.6,0-3.3-0.2-4.9-0.6v30.3c0,7.5-1,9.5-4.4,9.5c-1.5,0.1-3.1-0.3-4.4-1.1l-2,7.2 c2.7,0.8,5.5,1.2,8.3,1.2c5.7,0,9.6-2.4,11.4-6.8c1.1-2.9,1.5-6.3,1.5-13.3V53.4C28.4,53.9,26.6,54.1,24.8,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.5,36.9c0,4.3-3.5,7.7-7.7,7.8c-4.3,0-7.8-3.5-7.8-7.7s3.5-7.8,7.7-7.8C29,29.1,32.4,32.6,32.5,36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.7,52.5c-9.6,0-17.4,7.8-17.4,17.4s7.8,17.4,17.4,17.4c9.6,0,17.4-7.7,17.4-17.3 C73.1,60.3,65.3,52.5,55.7,52.5C55.7,52.5,55.7,52.5,55.7,52.5z M55.7,77.6c-4.3,0-7.7-3.5-7.7-7.7s3.5-7.7,7.7-7.7 c4.3,0,7.7,3.5,7.7,7.7c0,0,0,0,0,0.1C63.3,74.1,59.9,77.5,55.7,77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.1,53.5V57H125c-2.2-3-5.7-4.8-9.5-4.6c-9.3,0-16.3,7.7-16.3,17.3s6.7,17.4,16.3,17.4 c4.3,0,8.1-1.7,9.5-4.6h0.1V86h9.7V53.5H125.1z M117,77.5c-4.3,0-7.7-3.5-7.7-7.7c0-4.3,3.5-7.7,7.7-7.7c4.3,0,7.7,3.4,7.7,7.7 C124.8,74,121.3,77.4,117,77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9,7.5h3.5c0.6,0,1.3,0.1,1.9,0.3c0.6,0.2,1.1,0.6,1.5,1.1c0.5,0.6,0.7,1.4,0.6,2.1c0,0.6-0.1,1.1-0.4,1.6 c-0.2,0.4-0.6,0.8-1,1.1c-0.4,0.3-0.8,0.5-1.3,0.6c-0.5,0.1-0.9,0.1-1.4,0.1h-2.2v4.9h-1.3V7.5z M18.1,8.7v4.7h1.8 c2.1,0,3.2-0.8,3.2-2.3c0-0.7-0.3-1.3-0.8-1.7c-0.6-0.4-1.3-0.7-2-0.6H18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.1,9.2c1.2,1.2,1.8,2.7,1.8,4.4c0,1.6-0.6,3.2-1.8,4.4c-2.4,2.4-6.2,2.4-8.6,0c0,0,0,0,0,0 c-1.1-1.2-1.8-2.7-1.7-4.4c0-1.6,0.6-3.2,1.7-4.4C31.8,6.8,35.7,6.8,38.1,9.2C38.1,9.2,38.1,9.2,38.1,9.2z M37.1,17.1 c0.9-1,1.4-2.2,1.4-3.5c0-1.3-0.5-2.6-1.4-3.6c-1.8-1.9-4.7-1.9-6.6-0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.9,1-1.4,2.2-1.3,3.6 c0,1.3,0.4,2.6,1.3,3.5c1.7,1.9,4.7,2,6.5,0.2C37,17.3,37.1,17.2,37.1,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.7,7.5l2.5,9.7l0,0l2.8-9.7h1.2l-3.4,11.9h-1.3l-2.5-9.8l0,0l-2.7,9.8h-1.3L42.9,7.5h1.3l2.7,9.7l0,0 l2.7-9.7H50.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68,19.4H61V7.5H68v1.2h-5.7v4H68v1.2h-5.7v4.4H68V19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.8,14.3v5.2h-1.3V7.5H76c0.5,0,0.9,0.1,1.4,0.2c0.4,0.1,0.9,0.3,1.3,0.6c0.4,0.3,0.7,0.6,1,1 c0.2,0.5,0.4,1,0.4,1.6c0,0.8-0.3,1.5-0.8,2.1c-0.6,0.6-1.4,1-2.3,1.1c1,1.4,2.3,3.1,3.8,5.2h-1.5l-3.8-5.1H73.8z M73.8,8.7V13 h1.7c2,0,3-0.7,3-2.2c0-0.6-0.3-1.2-0.7-1.6c-0.5-0.4-1.2-0.6-1.9-0.6L73.8,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.5,19.4h-6.9V7.5h6.9v1.2h-5.7v4h5.7v1.2h-5.7v4.4h5.7V19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.2,19.4V7.5h3c0.6,0,1.3,0.1,1.9,0.2c0.6,0.1,1.2,0.3,1.7,0.6c0.5,0.3,1,0.7,1.4,1.1 c0.4,0.5,0.8,1.1,1,1.7c0.3,0.7,0.4,1.5,0.4,2.3c0,1-0.2,1.9-0.5,2.8c-0.3,0.8-0.9,1.4-1.5,1.9c-0.6,0.5-1.3,0.8-2.1,1 c-0.8,0.2-1.6,0.3-2.4,0.3L96.2,19.4z M97.4,18.3h0.6c1.6,0.1,3.2-0.3,4.5-1.1c1.1-0.9,1.7-2.2,1.6-3.6c0.1-1.4-0.4-2.7-1.4-3.6 c-1.1-0.9-2.5-1.3-3.9-1.3h-1.5L97.4,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.1,7.5h2.7c1.1-0.1,2.2,0.2,3.1,0.8c0.8,0.5,1.2,1.4,1.2,2.4c0,1.2-0.7,2.3-1.9,2.6 c1.4,0.2,2.5,1.4,2.4,2.9c0.1,1.3-0.7,2.4-1.9,2.8c-1,0.4-2,0.5-3,0.5h-2.6V7.5z M117.3,8.7v4.1h1.4c2.1,0,3.2-0.7,3.2-2 c0.1-0.6-0.2-1.2-0.8-1.6c-0.9-0.4-1.8-0.6-2.8-0.5H117.3z M117.3,18.3h1.1c0.9,0.1,1.9-0.1,2.8-0.4c0.7-0.3,1.1-1,1.1-1.8 c0-0.6-0.2-1.2-0.7-1.6c-0.6-0.4-1.3-0.6-2-0.6h-2.2V18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135,7.5l-3.8,6.8v5.1h-1.3v-5.3l-3.7-6.6h1.6l2.8,5.3l0,0l2.9-5.3H135z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogoDark);
export default __webpack_public_path__ + "static/media/footer_logo_dark.b2c90595.svg";
export { ForwardRef as ReactComponent };